<router-outlet />
<velocity-loader-dialog />
<p-dialog
  [visible]="appUpdater.updateDialogVisible()"
  [modal]="true"
  [dismissableMask]="false"
  [closeOnEscape]="false"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  styleClass="app-update-dialog"
  header="New version available"
>
  <p class="app-update-dialog__message">Please refresh the page to update to the latest version</p>
  <ng-template #footer>
    <div class="app-update-dialog__actions">
      <p-button
        label="Close"
        [outlined]="true"
        severity="secondary"
        (onClick)="appUpdater.closeDialog()"
      ></p-button>
      <p-button label="Refresh" (onClick)="appUpdater.installUpdate()"></p-button>
    </div>
  </ng-template>
</p-dialog>
<p-toast />
<p-toast key="property-created">
  <ng-template let-message pTemplate="message">
    <!-- Match default p-toast layout (icon + messageText) so sizing matches
         delete/success toasts on the generic <p-toast />, with an extra link. -->
    <svg
      class="p-toast-message-icon"
      data-p-icon="check"
      aria-hidden="true"
    ></svg>
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary }}</div>
      @if (message.detail) {
        <div class="p-toast-detail">{{ message.detail }}</div>
      }
    </div>
  </ng-template>
</p-toast>
